import _AbstractBlock from "./_AbstractBlock";

/**
 * Google AdSense Block immediately shown on startup
 *
 * @author che, bgr
 */
customElements.define(
	"esc-adsense-block",
	class extends _AbstractBlock {
		connectedCallback() {
			this.addAdSense();
		}
	},
);
